<template>
    <div class="show-mobile">
        <div><img src="/themes/web/assets/images/resp-logo.svg" alt=""></div>
        <div class="show-mobile-computer mobile-hide"><img src="/themes/web/assets/images/resp-computer.svg" alt=""></div>
        <div class="mobile-hide">Hãy mở rộng trình duyệt để tiếp tục sử dụng!</div>
        <div class="show-mobile-or mobile-hide">Hoặc</div>
        <div class="show-mobile-title">Tải Ứng dụng</div>
        <div class="show-mobile-desc">Ứng dụng tương thích trên mọi điện thoại thông minh và máy tính bảng, giúp học viên có thể học tập mọi lúc mọi nơi.</div>
        <div class="show-mobile-buttons">
            <a class="show-mobile-android" href="https://apps.apple.com/vn/app/ismart-pro2/id1624442836">
                <img src="/themes/web/assets/images/appstore.svg" alt="">
            </a>
            <a class="show-mobile-ios" href="https://play.google.com/store/apps/details?id=ismart.edu.vn.lisa">
                <img src="/themes/web/assets/images/googleplay.svg" alt="">
            </a>
        </div>
    </div>   
</template>

<script>

export default {
 
}
</script>

<style scoped>

</style>
